import { render, staticRenderFns } from "./NestedCollectionFilter.vue?vue&type=template&id=0b81d7f6"
import script from "./NestedCollectionFilter.vue?vue&type=script&lang=js"
export * from "./NestedCollectionFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports